import { Link } from 'react-router-dom';

export function FooterSection() {
  return (
    <footer className="bg-black py-12 md:py-16 px-4 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 md:gap-12">

          {/* Brand */}
          <div className="flex items-center gap-3">
            <img alt="Logo" className="h-8 w-8 md:h-10 md:w-10 rounded-lg object-cover opacity-60" src="/777icon.jpg" />
            <span className="text-slate-500 font-bold uppercase tracking-[0.2em] text-xs md:text-sm">© 2025 Golden 777 Casino</span>
          </div>

          {/* Valid links only */}
          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-slate-500 text-xs font-bold uppercase tracking-widest">
            <Link className="hover:text-white transition-colors" to="/privacy-policy">Privacy Policy</Link>
            <Link className="hover:text-white transition-colors" to="/terms-and-conditions">Terms &amp; Conditions</Link>
          </div>

        </div>

        <div className="mt-10 md:mt-12 pt-6 md:pt-8 border-t border-white/5 text-center">
          <p className="text-[10px] text-slate-600 uppercase tracking-[0.2em]">
            18+ Play Responsibly. Gambling can be addictive. Golden 777 is a licensed global entertainment provider.
          </p>
        </div>
      </div>
    </footer>
  );
}
